import { useMemo } from 'react'
import { TextInfo } from '../../../components/text'
import { P2TextDescription } from 'react-bootstrap-common-script';
import { ChangeOwnershipReasonCode } from '../../../utils/code-converter';

interface ReviewEligibilityProps{
  reasonCode?: string
}

function ReviewEligibility({...props}:ReviewEligibilityProps) {
  
  const processReasonDescription = useMemo(():string=>{
    return ChangeOwnershipReasonCode.find(e=>e.code === props.reasonCode)?.label ?? "";
  },[props.reasonCode])
  const situationDescription = useMemo(():string=>{
    return ChangeOwnershipReasonCode.find(e=>e.code === props.reasonCode)?.hdb_description ?? "";
  },[props.reasonCode])


  return (
    <div className='px-4 pt-4 pb-5'>
      <P2TextDescription color='#000' title='Eligibility'/>
      <div className='mt-4'>
        <TextInfo variant='column' title='Reason for change of ownership' description={processReasonDescription}/>
      </div>
      <div className='mt-4'>
        <TextInfo variant='column' title='Which of the following best describes your situation?' description={situationDescription}/>
      </div>
    </div>
  )
}

export default ReviewEligibility